<template>
  <div class="nav">
    <a @click="$emit('back')" class="back">
      <img src="https://img2.233.com/wx/union/wap/leadaclass/back-icon.png">
    </a>
    <h1>{{name}}</h1>
    <div class="right">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: "Nav",
  props: {
    name: {
      type: String,
      default: ""
    }
  }
}
</script>

<style lang="scss" scoped>
.nav{
  position: relative;
  background: #fff;
  .back{
    position: absolute;
    top: 0;
    left: 15px;
    line-height: 48px;
    img{
      height: 13px;
    }
  }
  h1{
    color: #000;
    font-size: 18px;
    text-align: center;
    font-weight: 800;
    line-height: 48px;
  }
  .right{
    position: absolute;
    top: 0;
    right: 15px;
    line-height: 48px;
  }
}
</style>